import React, { useEffect, useState } from 'react';
import Layout from '../components/layout/Layout';
import LoadingSpinner from '../components/common/LoadingSpinner';
import { useAuth } from '../contexts/AuthContext';
import { getProfile } from '../api/franchise.api';
import styles from './SettingsPage.module.css';

function formatDate(iso: string): string {
  if (!iso) return '-';
  const d = new Date(iso);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export default function FranchiseSettingsPage() {
  const { franchiseId, franchiseName } = useAuth();

  const [profile, setProfile] = useState<{
    id: string;
    name: string;
    isActive: boolean;
    createdAt: string;
  } | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!franchiseId) return;
    setLoading(true);
    getProfile(franchiseId)
      .then(setProfile)
      .catch((e) => console.error(e))
      .finally(() => setLoading(false));
  }, [franchiseId]);

  return (
    <Layout>
      <div className={styles.page}>
        <h1 className={styles.title}>프랜차이즈 설정</h1>

        {loading ? (
          <LoadingSpinner />
        ) : (
          <section className={styles.card}>
            <h2 className={styles.cardTitle}>프랜차이즈 정보</h2>
            <div className={styles.infoGrid}>
              <div className={styles.infoRow}>
                <span className={styles.infoLabel}>프랜차이즈 이름</span>
                <span className={styles.infoValue}>{profile?.name || franchiseName || '-'}</span>
              </div>
              <div className={styles.infoRow}>
                <span className={styles.infoLabel}>상태</span>
                <span className={styles.infoValue}>
                  {profile?.isActive ? '활성' : '비활성'}
                </span>
              </div>
              <div className={styles.infoRow}>
                <span className={styles.infoLabel}>가입일</span>
                <span className={styles.infoValue}>
                  {profile?.createdAt ? formatDate(profile.createdAt) : '-'}
                </span>
              </div>
              <div className={styles.infoRow}>
                <span className={styles.infoLabel}>프랜차이즈 ID</span>
                <span className={styles.infoValueMono}>{profile?.id || '-'}</span>
              </div>
            </div>
          </section>
        )}
      </div>
    </Layout>
  );
}
